import { ContractManagementContext } from "../providers/ContractManagementProvider";
import { useContext } from "react";

export default function useContractContext() {
  return useContext(ContractManagementContext);
}
